


































import { Component, Prop, Vue } from 'vue-property-decorator';

import { getWordInitials } from '@/utils/getWordInitials';

import ResumeCard from '@/componentsV2/molecules/ResumeCard/ResumeCard.vue';

@Component({
  components: {
    ResumeCard
  }
})
export default class CustomerDetail extends Vue {
  @Prop({ default: null }) customerData!: any;
  @Prop({ default: true }) loadingCustomer!: boolean;

  get fallbackThumbPath() {
    const { name, lastname } = this.customer;

    return getWordInitials(`${name} ${lastname}`);
  }

  get thumbPath() {
    if (
      this.customerData &&
      this.customerData.image &&
      this.customerData.image.id
    ) {
      return JSON.parse(this.customerData.image.publicPath).small;
    }

    return '';
  }

  get customer() {
    return this.customerData.customer;
  }
}
